/**
 * Step 2: Link Promos & Funding (Optional)
 * 
 * Link existing promos or create new ones:
 * - Search and link existing promos
 * - Add new promo (quick creation)
 * - Set funding configuration
 * - Can be skipped entirely
 */

import React from 'react';
import { Form } from 'react-bootstrap';
import { CampaignFormData, CampaignValidationErrors } from '../../../../../api/promos/types';
import './StepperButtons.css';
import './StepperFormStyles.css';
import './StepLinkPromos.css';

interface StepLinkPromosProps {
  formData: CampaignFormData;
  validationErrors: CampaignValidationErrors;
  onChange: (updates: Partial<CampaignFormData>) => void;
  onNext: () => void;
  onPrevious: () => void;
  onSkip: () => void;
}

const StepLinkPromos: React.FC<StepLinkPromosProps> = ({
  formData,
  validationErrors,
  onChange,
  onNext,
  onPrevious,
  onSkip,
}) => {

  return (
    <div>
      {/* Step Header */}
      <div className="mb-4">
        <h5 className="mb-2">Link Promos <span className="text-muted">(Optional)</span></h5>
        <p className="text-muted mb-0">
          Link existing promos or create new ones. You can skip this and add later.
        </p>
      </div>

      {/* No Data Available Message */}
      <div className="text-center py-5">
        <div className="mb-3">
          <i className="ph-info display-4 text-muted"></i>
        </div>
        <h6 className="text-muted mb-2">No Promos or Funding Available</h6>
        <p className="text-muted mb-4" style={{ maxWidth: '500px', margin: '0 auto' }}>
          Promo and funding data is not available from the backend at this time.<br/>
          You can proceed to the next step to review and activate your campaign.
        </p>
      </div>

      {/* Funding Section - Disabled */}
      <div className="funding-section">
        <div className="funding-section-header">
          <h5 className="mb-2">Funding <span className="text-muted">(Optional)</span></h5>
        </div>

        <div className="funding-checkbox-container">
          <div className="campaign-checkbox">
            <input
              type="checkbox"
              id="default-funding"
              checked={false}
              disabled={true}
            />
          </div>
          <label htmlFor="default-funding" className="stepper-form-label" style={{ marginBottom: 0, opacity: 0.5 }}>
            Set Default Funding
          </label>
        </div>

        <div className="funding-input-container">
          <Form.Group className="stepper-form-group">
            <Form.Label className="stepper-form-label" style={{ opacity: 0.5 }}>
              Funded By
            </Form.Label>
            <Form.Control
              type="text"
              className="stepper-form-control"
              value=""
              disabled={true}
              placeholder="Funding not available"
            />
          </Form.Group>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="stepper-buttons-container">
        <button
          type="button"
          className="stepper-back-button"
          onClick={onPrevious}
        >
          <i className="ph-arrow-left"></i>
          Back
        </button>
        
        <div className="stepper-buttons-right">
          <button
            type="button"
            className="stepper-skip-button"
            onClick={onSkip}
          >
            Skip this Step
          </button>
          
          <button
            type="button"
            className="stepper-next-button"
            onClick={onNext}
          >
            Next
            <i className="ph-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepLinkPromos;